// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"356":"59356474","462":"49e33efd","488":"7a876c9d","793":"86fcc913","983":"6bb44b03","987":"58caf737"}[chunkId] + ".chunk.js";
};